// Grade validation helpers shared by the examiner grading screens.
//
// Each rubric criterion is scored 0-20 and a section has 5 criteria, so a valid
// section grade is an integer in [0, 100]. These helpers guarantee the UI never
// sends a NaN / non-finite / out-of-range grade to the backend.

export const MIN_CRITERION_SCORE = 0;
export const MAX_CRITERION_SCORE = 20;
export const CRITERIA_PER_SECTION = 5;
export const MAX_SECTION_GRADE = MAX_CRITERION_SCORE * CRITERIA_PER_SECTION; // 100

/**
 * Sum the per-criterion scores. If any value is missing or non-numeric the
 * result is NaN, so the caller can reject the whole submission rather than
 * silently coercing a bad field to 0.
 */
export function sumCriterionScores(breakdown = {}) {
  return Object.keys(breakdown).reduce((total, key) => {
    const value = Number(breakdown[key]);
    return Number.isFinite(value) ? total + value : NaN;
  }, 0);
}

/** True only for a finite section grade within the allowed range. */
export function isValidSectionGrade(grade) {
  return (
    Number.isFinite(grade) &&
    grade >= MIN_CRITERION_SCORE &&
    grade <= MAX_SECTION_GRADE
  );
}
